/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useRef, useState } from "react";
import { OwlSlider } from "../Common";

const Utilities = () => {
  
  return (
    <>
    <section className="section babies-coming">
      <div className="container"> 
          <h2>Are you ready?</h2>
          <h3 className="orange-text">Babies Are Coming…</h3>
        <div className="row">
          <div className="col-md-9"> 
          <p>On 06/06/22 the first batch of Babies will arrive on Earth.</p>
          <p>Holding one of the Super Creators - Gen Z Tokens allows access to the Super Creator Academy.</p>
          <p>Did you know the 5500 Super Creator Jr have an Element Trait? Collect 5 of the different Element Traits in order to mint  the Limited Edition Super Baby.</p>
          <p>See <a href="#">What's Your Super Creators Powers</a> section for more info.</p>
          </div>
          <div className="col-md-3"> 
          <img src="assets/images/cr-design.gif" alt="" title="" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>

    <section className="section creators-powers">
      <div className="container">
      <h2 class="mb-3">What's your super creators powers</h2>
      <p>When holding a Super Creator Genesis or Baby, here’s what your new superpowers get you:</p>
        <div className="row mt-5">
        <div className="col-md-4 order-md-2">  
            <img src="assets/images/sc-academy.png" alt="" title="" className="img-fluid" />
        </div>
        <div className="col-md-8 order-md-1"> 
          <h3 className="orange-text">Super creators academy</h3>
          <p>The Super Creator Academy (SCA), is a 24 hour training hub. EVERY Super Creator was sent here with a purpose; to make a difference in the world. And in order to fulfil this mission, Super Creator token holders need to be equipped with the right tools, skills and knowledge to not only satisfy their needs and desires but to also be able to give back and assist the community as a whole.</p>
          </div>
        </div>
        <div className="row mt-5">
        <div className="col-md-4">  
            <img src="assets/images/training-academy.png" alt="" title="" className="img-fluid" />
          </div>
        <div className="col-md-8">  
          <p className="orange-text mobile-30">The 24 hour training academy will allow all Super Creator Genesis and Super Creators - Gen Z token holders to develop the skills and expertise that the Super Creators use to impact millions of lives across the globe, generate income from 6,7 and even 8 Figures+ whilst also being fulfilled at the same time.</p>
          </div> 
        </div>
      </div>
    </section>

    <section className="section babies-coming">
      <div className="container"> 
        <div className="row">
          <div className="col-md-7"> 
          <p>During each day of the academy, Super Creator token holders will have the option to choose between a multitude of edutainment programs (education + entertainment programs have been shown to get the best results in people’s lives, compared to purely educational style training) from: Growing a social media following to millions, generating wealth and abundance through online marketing, NFTs and serving beyond self, yoga + meditation, law of attraction and spiritual trainings, even speaker training and much more to equip our holders with the abilities to make the most impact and fulfilled income in this day and age.</p> 
          </div>
          <div className="col-md-5"> 
          <img src="assets/images/yoga-meditation.png" alt="" title="" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>

    <section className="section creators-powers">
      <div className="container">
      <h2 class="mb-3">Super creators - gen z, bonuses & much more</h2> 
        <div className="row"> 
        <div className="col-md-12"> 
          <h3 className="orange-text">SUPER CREATORS</h3>
          <p>On 2/2/22 4 types of Super Creators Landed On Earth. These 2,222 sentient beings consist of: Divine Masculine, Divine Feminine, Lightworkers Of The World & Activated Chakras.</p>
          <div className="row">
            <div className="col-sm-9">
              <p>When a <b>Divine Masculine</b> and <b>Divine Feminie</b> come together, they ignite a spark and whilst they train at the Super Creators Academy, if they remain together for an initial 90 days they will create a divine fusion: A Super Creators Jr*.</p>
            </div>
            <div className="col-sm-3">
              <img src="assets/images/divine-masculine.png" alt="" title="" className="img-fluid" />
            </div>
          </div>
          <p>They can then create another baby <b>every 30 days</b> up until a maximum of 5,500 Super Creators Jr have manifested.</p>
          </div>
        </div> 
      </div>
    </section>

    <section className="section babies-coming">
      <div className="container">  
        <div className="row"> 
        <div className="col-md-12">  
          <div className="row">
            <div className="col-sm-10">
              <h3 className="orange-text">Super babies & the elements</h3> 
              <p>Collect a set of five Super Creators Jr with each element trait (Earth, Water, Fire, Air & Space) and hold for 90 days to mint a Super Baby. The next minting opportunity with this token set is after another 180 days. There are ONLY 55 SUPER BABIES to be minted within the Super Creators - Gen Z Collection of 5555 tokens. These 55 tokens will bring major benefits to the holder that are yet to be disclosed..</p>
            </div>
            <div className="col-sm-2 align-self-center">
              <img src="assets/images/baby-elem.png" alt="" title="" className="img-fluid" />
            </div>
          </div> 
          </div>
        </div> 
      </div>
    </section>

    <section className="section creators-powers">
      <div className="container">
      <h3 className="orange-text">Lightworkers</h3>
      <p>22 Lightworkers were also sent within this 2,222 collection with the same abilities as the Divine Masculine and Divine Feminine. However the only difference is that these 22 Super Creators are rumored to resemble Light Workers that exist in human form, such as: Tony Robbins, Sadhguru, Master Sri Akarshana, Grandmaster Akshar, Aarti Chabria amongst others.</p>
      <div className="text-center"><img src="assets/images/lightworker-user.png" alt="" title="" className="img-fluid" /></div>
      <p>Holders of these Lightworkers also have the abilities to make Super Creators Jr (Lightworkers have genders that match their human counterparts), along with bonus perks that correspond to what the lightworkers special powers are in the physical world. Holding some of the Lightworkers may unlock unique benefits that will be announced in the future.</p>
      </div>
    </section>

    <section className="section babies-coming">
      <div className="container">   
          <div className="row align-items-center">
            <div className="col-sm-10">
              <h3 className="orange-text">Activated chakra</h3> 
              <p>There are also 49 Dual-Gender Super Creators who have found the ability to activate one of their 7 chakras; Root, Sacral, Solar Plexus, Heart, Throat, Third Eye or Crown.</p>
              <p>Each chakra has been activated by 7 Super Creators (making a total of 7 Super Creators x 7 Chakras = 49 Activated Super Creators)</p>
              <p>These Activated Chakra tokens are dual gender allowing them to create Super Creators Jr with either a male or a female, they possess an even greater capability!</p>
            </div>
            <div className="col-sm-2">
              <img src="assets/images/active-chakras.png" alt="" title="" className="img-fluid" />
            </div>
          </div> 
      </div>
    </section>

    <section className="section creators-powers">
      <div className="container"> 
      <p>If you hold one of each Activated Chakra (a total of 7) for 90 days, you will be selected by one of the 7 Legendary Super Creators to take on a new Divine Mission, meaning you will be equipped with even greater rewards to fulfil this higher purpose.</p>
      <p>These Legendaries are only spoken of in myths and have not been seen by real human eyes in Web 2.0 or Web 3.0 YET…</p>
      <div className="text-center"><img src="assets/images/active-chakras-multiple.png" alt="" title="" className="img-fluid" /></div>
      </div>
    </section>

    <section className="section babies-coming">
      <div className="container"> 
      <h3 className="orange-text">Legendaries</h3>
      <p>Legends have it that the 7 Divine Legendaries have been reserved EXCLUSIVE INNER ACCESS at the Creators Land, not only in the Metaverse but also in the physical world too!</p>
      <p>These Legendaries have been rumoured to have specific dates where they recharge and increase their abilities at various venues exclusive solely to Master Sri Akarshana, The IAC Team and Lightworkers of the world.</p>
      <p>There has been talk that with just one perk from these Legendary Super Creators, the lives of many generations can be positively impacted FOREVER</p>
      <p>We will wait for the first Legendary to be created when once a lucky being possesses all 7 Activated Chakras…</p>
      <em>*Note Super Creators - Gen Z cannot produce babies but they have the same access to the SCA.</em>
      <div className="text-center mt-3"><img src="assets/images/legendaries.png" alt="" title="" className="img-fluid" /></div>
      </div>
    </section>

    <div className="join-sec">
        <div
          className="container wow fadeInDown"
          data-wow-duration="1s"
          style={{ visibility: "visible", animationDelay: "0.1s" }}
        >
          <div id="particles-js-2" className="particles-js"></div>
          <div className="join-us">
            <div className="title2">
              Join the Super Creators Discord Community
            </div>
            <a
              href="https://discord.gg/RM9DEK4KV7"
              target="_blank"
              className="btn"
            >
              Join Discord community
            </a>
          </div>
        </div>
      </div>

      <div className="community-testimonials">
        <div className="container">
          <h2 className="mb-4">Super Creator Community</h2>
          <div className="subtitle">
            See how excited our community members are about the project!
          </div>
          <OwlSlider
            {...{
              nav: true,
              loop: true,
              dots: false,
              margin: 30,
              stagePadding: 0,
              autoplay: false,
              autoplayTimeout: 3000,
              responsive: {
                0: {
                  items: 1,
                  stagePadding: 0,
                  margin: 0,
                },
                575: {
                  items: 2,
                  nav: true,
                },
                768: {
                  items: 2,
                  nav: false,
                },
                991: {
                  items: 3,
                },
                1280: {
                  items: 4,
                },
                1600: {
                  items: 4,
                },
              },
            }}
          >
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665021255?h=b4cb1d9a1e&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665020959?h=533949a274&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665018907?h=f0c5f1eb26&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665018503?h=b1bed13b28&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017809?h=e5be5e856f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017507?h=652c7ac781&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017225?h=cb53a53efb&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017589?h=b2277730d9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017163?h=81509fb548&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017083?h=545ab5bc3a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017036?h=d2e0b00a36&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665016965?h=1fa443f49f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665016915?h=81966a278f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665016830?h=f4d538c40a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665021449?h=63839c924a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665016782?h=ec18d63650&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="test-video-inside">
              <iframe
                src="https://player.vimeo.com/video/665017687?h=24bf5b5d1c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                width="100%"
                height="350"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </OwlSlider>
        </div>
      </div>


    </>
  );
};

export default Utilities;
